// Who may use the hub. Any Google account can sign in to the Firebase project,
// so after sign-in the app checks this list and shows a no-access screen to
// everyone else. Display gate only — the real enforcement is isStaff() in
// firestore.rules / storage.rules and functions/staffAuth.js. Keep all four
// lists the same.
export const STAFF_EMAILS = [
  'cmgsalinas@gmail.com',
  'content.core6@gmail.com',
  'al.teamcmg@gmail.com',
];

export function isStaffUser(user) {
  if (!user || user.emailVerified !== true || typeof user.email !== 'string') return false;
  return STAFF_EMAILS.includes(user.email.trim().toLowerCase());
}
